export const MINIMUM_DELIVERY_AMOUNT_WARNING_ID = {
  minimum: 'delivery-minimum-banner',
  addMore: 'add-more-delivery-minimum-banner',
};
